import Error from "next/error";
import React from "react";
import Head from "next/head";

import PartnerServiceDetails from "@/components/partners/partner-service-details";
import SeoMetaData from "@/components/utils/seo-metadata";
import pageSeoData from "@/data/seo/page-data.json";
import upsReadyProgramData from "@/data/carriers/ups-ready-program.json";
import { PageSeoHeaderProps } from "@/@types/SeoHeader";

interface Props extends PageSeoHeaderProps {
  partner: string;
  readyProgramDetails: any;
}

const ReadyProgram = ({ partner, readyProgramDetails, seoData }: Props) => {
  if (partner != "ups") {
    return <Error statusCode={404} title="Page Not Found" />;
  }

  return (
    <>
      <Head>
        <title>{seoData.title}</title>
        <SeoMetaData data={seoData} />
      </Head>

      <PartnerServiceDetails
        servicesDetails={readyProgramDetails}
        partnerName="ups-canada"
        hasConnectionSteps
      />
    </>
  );
};

export async function getServerSideProps(context: any) {
  const { partner } = context.params;

  return {
    props: {
      partner,
      seoData: pageSeoData.PARTNER_UPS_READY_PROGRAM,
      readyProgramDetails: upsReadyProgramData,
    },
  };
}

export default ReadyProgram;
